import { gql } from '@apollo/client'

export const CURRENCIES_QUERY = gql`
  query Currencies {
    currencies
  }
`

export const PAIRED_CURRENCIES_QUERY = gql`
  query PairedCurrencies {
    pairedCurrencies
  }
`
